import { Button } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import { AnnouncementsCardGrid } from './AnnouncementsCardGrid';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  viewAllButton: {
    textTransform: 'none',
  },
}));

interface AnnouncementsCardProps {
  max?: number;
}

export const AnnouncementsCard = ({ max = 4 }: AnnouncementsCardProps) => {
  const classes = useStyles();

  return (
    <InfoCard
      title="Announcements"
      action={
        <Button
          size="small"
          endIcon={<ArrowForwardIcon />}
          className={classes.viewAllButton}
          href="/announcements"
        >
          View all
        </Button>
      }
    >
      <AnnouncementsCardGrid max={max} />
    </InfoCard>
  );
};
